import { MessageCircle, Play } from "lucide-react";

import content from "@/content/contato.json";

interface Data {
  number: number;
  msg: string;
  primary_btn: string;
  secundary_btn: string;
}

const data: Data = content;

const WHATSAPP_NUMBER = data.number;
const WHATSAPP_MESSAGE = encodeURIComponent(data.msg);
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

interface Btn {
  className?: string;
}

const WhatsApp = ({ className }: Btn) => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <MessageCircle className="h-5 w-5 transition-transform group-hover:scale-110" />
      {data.primary_btn}
    </a>
  );
};

export const Secundary_Btn = ({ className }: Btn) => {
  return (
    <a href="#portfolio" className={className}>
      <Play className="h-5 w-5" />
      {data.secundary_btn}
    </a>
  );
};

export default WhatsApp;
